import { render } from "./outlined-button-with-icon.vue?vue&type=template&id=7c2a3cb8&scoped=true"
import script from "./outlined-button-with-icon.vue?vue&type=script&lang=js"
export * from "./outlined-button-with-icon.vue?vue&type=script&lang=js"

import "./outlined-button-with-icon.vue?vue&type=style&index=0&id=7c2a3cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2a3cb8"]])

export default __exports__